import * as d3 from 'd3-selection'

/*
 * Shortens a text label if its length exceeds the `maxWidth`
 */
export default function (selection, node) {
  selection.each(function () {
    let back = d3.select(this)
                 .selectAll('.back-button-container')
                 .data(node ? [node] : [])

    // Start fresh. Kind of a hack but worried about event listeners on old back buttons
    back.selectAll('*').remove()
    back.exit().remove()

    back.enter()
        .append('foreignObject')
        .attr('class', 'back-button-container')
        .merge(back)
        .raise()
        .append(() => node)
        .select(function () {
          d3.select(this.parentNode) // the foreign object
            .attr('width', this.offsetWidth)
            .attr('height', this.offsetHeight)

          return this
        })
  })
}
